class ObserverProxy {
  static create() {
    return new ObserverProxy()
  }
  constructor() {
    this.init()
  }

  init() {
    /**
     * @private @member
     */
    this.observers = new Map()
  }

  observe(key, callback) {
    if (!this.observers.has(key)) {
      this.observers.set(key, new Set())
    }

    const observerSet = this.observers.get(key)
    observerSet.add(callback)
  }

  unobserve(key, callback) {
    if (!this.observers.has(key)) return

    const observerSet = this.observers.get(key)
    observerSet.delete(callback)
  }

  getObservers() {
    return Array.from(this.observers.entries())
      .map(([key, observerSet]) => {
        return [key, Array.from(observerSet)]
      })
      .reduce((acc, [key, observers]) => ({ ...acc, [key]: observers }), {})
  }

  has(key, callback) {
    if (!this.observers.has(key)) return false
    const observerSet = this.observers.get(key)
    return observerSet.has(callback)
  }

  destroy() {
    this.init()
  }
}

export default ObserverProxy
